import _, { pick, defaults } from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { BaseSchemaProcessor } from './base-schema-processor';

export class AssetWithBIDataSchemaProcessor extends BaseSchemaProcessor {
  constructor(options) {
    super(options);
    this.scope = options.scope;
    this.state = options.state;
    this.i18n = options.i18n;
  }
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = cloneDeep(entitySchema);

    const { campaignId } = (this.scope && this.scope.values) || {};
    const { CampaignType } = this.state || {};

    const {
      MMAAssetReportAccountLevel,
      AudienceAssetReport,
      AssetGridForPmaxCampaign,
      SearchAssetConversionColumn,
      AssetBasedEditorialForRSA,
      AssetBasedEditorialForAIM,
    } = this.Permissions.dynamic;

    const EditorialStatusEnumMap = {
      "Enum.EditorialStatus'Approved'": 'Approved',
      "Enum.EditorialStatus'ApprovedLimited'": 'ApprovedLimited',
      "Enum.EditorialStatus'Rejected'": 'Rejected',
      "Enum.EditorialStatus'Pending'": 'Pending',
      "Enum.EditorialStatus'ApprovedLimitedAppealRejected'": 'ApprovedLimitedAppealRejected',
      "Enum.EditorialStatus'RejectedAppealRejected'": 'RejectedAppealRejected',
      "Enum.EditorialStatus'AppealPending'": 'AppealPending',
    };

    updatedSchema.properties.AssetEditorialStatus = _.defaults({
      chooseType: 'checkbox',
      enum: _.keys(EditorialStatusEnumMap),
      enumValueMap: EditorialStatusEnumMap,
      localized: _.mapObject(EditorialStatusEnumMap, value => this.i18n.getString(`Asset_EditorialStatus_${value}`)),
    }, updatedSchema.properties.AssetEditorialStatus);

    const showAssetBasedEditorial = campaignId && ((AssetBasedEditorialForRSA && CampaignType === 'Default') || (AssetBasedEditorialForAIM && CampaignType === 'Audience'));


    updatedSchema.properties = pick(
      updatedSchema.properties,
      [
        'AssetIsBlocked',
        'AssetText',
        'AssetAssetSource',
        'AssociationType',
        'UsedByCount',
        AssetGridForPmaxCampaign ? 'UsedByAssetGroupCount' : '',
        'PinnedBitmask',
        'PerformanceMetricsImpressions',
        'PerformanceMetricsClicks',
        'PerformanceMetricsCTR',
        'PerformanceMetricsSpend',
        SearchAssetConversionColumn ? 'PerformanceMetricsConversionsCredit' : '',
        SearchAssetConversionColumn ? 'PerformanceMetricsAdvertiserReportedRevenue' : '',
        showAssetBasedEditorial ? 'AssetEditorialStatus' : '',
      ]
    );


    updatedSchema.properties.AssetAssetSource = defaults({
      chooseType: 'checkbox',
      enumType: 'AssetSource',
      enum: [
        "Enum.AssetSource'AdvertiserProvided'",
        "Enum.AssetSource'AutoGenerated'",
      ],
      enumValueMap: {
        "Enum.AssetSource'AdvertiserProvided'": 'AdvertiserProvided',
        "Enum.AssetSource'AutoGenerated'": 'AutoGenerated',
      },
    }, updatedSchema.properties.AssetAssetSource);

    updatedSchema.properties.AssetIsBlocked = defaults({
      title: this.i18n.getString('Status'),
      localized: {
        false: this.i18n.getString('Active'),
        true: this.i18n.getString('Deleted'),
      },
    }, updatedSchema.properties.AssetIsBlocked);

    updatedSchema.properties.AssociationType = defaults((MMAAssetReportAccountLevel || AudienceAssetReport) ? {
      enum: [
        "Enum.AssetAssociationType'Headlines'",
        "Enum.AssetAssociationType'Descriptions'",
        "Enum.AssetAssociationType'OriginalImage'",
        "Enum.AssetAssociationType'SquareLogoMedia'",
        "Enum.AssetAssociationType'LandscapeLogoMedia'",
        "Enum.AssetAssociationType'LandscapeImageMedia'",
        "Enum.AssetAssociationType'SquareImageMedia'",
        "Enum.AssetAssociationType'ImageMedia1X2'",
        "Enum.AssetAssociationType'ImageMedia133X100'",
        "Enum.AssetAssociationType'ImageMedia15X10'",
        "Enum.AssetAssociationType'ImageMedia178X100'",
        "Enum.AssetAssociationType'ImageMedia4X1'",
        "Enum.AssetAssociationType'ImageMedia93X100'",
        "Enum.AssetAssociationType'ImageMedia155X100'",
        "Enum.AssetAssociationType'ImageMedia169X100'",
        "Enum.AssetAssociationType'ImageMedia172X100'",
        "Enum.AssetAssociationType'ImageMedia201X100'",
        "Enum.AssetAssociationType'ImageMedia200X100'",
        "Enum.AssetAssociationType'ImageMedia153X100'",
        "Enum.AssetAssociationType'ImageMedia124X100'",
        "Enum.AssetAssociationType'ImageMedia120X100'",
        "Enum.AssetAssociationType'DisplayCreativeImage'",
        "Enum.AssetAssociationType'CallToAction'",
      ],
      enumValueMap: {
        "Enum.AssetAssociationType'Headlines'": 'Headlines',
        "Enum.AssetAssociationType'Descriptions'": 'Descriptions',
        "Enum.AssetAssociationType'OriginalImage'": 'OriginalImage',
        "Enum.AssetAssociationType'SquareLogoMedia'": 'SquareLogoMedia',
        "Enum.AssetAssociationType'LandscapeLogoMedia'": 'LandscapeLogoMedia',
        "Enum.AssetAssociationType'LandscapeImageMedia'": 'LandscapeImageMedia',
        "Enum.AssetAssociationType'SquareImageMedia'": 'SquareImageMedia',
        "Enum.AssetAssociationType'ImageMedia1X2'": 'ImageMedia1X2',
        "Enum.AssetAssociationType'ImageMedia15X10'": 'ImageMedia15X10',
        "Enum.AssetAssociationType'ImageMedia133X100'": 'ImageMedia133X100',
        "Enum.AssetAssociationType'ImageMedia178X100'": 'ImageMedia178X100',
        "Enum.AssetAssociationType'ImageMedia4X1'": 'ImageMedia4X1',
        "Enum.AssetAssociationType'ImageMedia93X100'": 'ImageMedia93X100',
        "Enum.AssetAssociationType'ImageMedia155X100'": 'ImageMedia155X100',
        "Enum.AssetAssociationType'ImageMedia169X100'": 'ImageMedia169X100',
        "Enum.AssetAssociationType'ImageMedia172X100'": 'ImageMedia172X100',
        "Enum.AssetAssociationType'ImageMedia201X100'": 'ImageMedia201X100',
        "Enum.AssetAssociationType'ImageMedia200X100'": 'ImageMedia200X100',
        "Enum.AssetAssociationType'ImageMedia153X100'": 'ImageMedia153X100',
        "Enum.AssetAssociationType'ImageMedia124X100'": 'ImageMedia124X100',
        "Enum.AssetAssociationType'ImageMedia120X100'": 'ImageMedia120X100',
        "Enum.AssetAssociationType'DisplayCreativeImage'": 'DisplayCreativeImage',
        "Enum.AssetAssociationType'CallToAction'": 'CallToAction',
      },
    } : {
      enum: [
        "Enum.AssetAssociationType'Headlines'",
        "Enum.AssetAssociationType'Descriptions'",
      ],
      enumValueMap: {
        "Enum.AssetAssociationType'Headlines'": 'Headlines',
        "Enum.AssetAssociationType'Descriptions'": 'Descriptions',
      },
    }, updatedSchema.properties.AssociationType);

    if (AudienceAssetReport) {
      updatedSchema.properties.AssociationType.enum.push("Enum.AssetAssociationType'VideoMedia16X9'");
      updatedSchema.properties.AssociationType.enumValueMap["Enum.AssetAssociationType'VideoMedia16X9'"] = 'VideoMedia16X9';
    }

    updatedSchema.properties.PinnedBitmask = defaults({
      enum: [
        "Enum.PinnedAssetPositionType'Position1'",
        "Enum.PinnedAssetPositionType'Position2'",
        "Enum.PinnedAssetPositionType'Position3'",
        "Enum.PinnedAssetPositionType'None'",
      ],
      enumValueMap: {
        "Enum.PinnedAssetPositionType'Position1'": 'Position1',
        "Enum.PinnedAssetPositionType'Position2'": 'Position2',
        "Enum.PinnedAssetPositionType'Position3'": 'Position3',
        "Enum.PinnedAssetPositionType'None'": 'None',
      },
    }, updatedSchema.properties.PinnedBitmask);

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    _.extendOwn(odataOptions.custom, {
      'Asset/EditorialStatus': {
        eq: (filterValues) => {
          const queryStr = `Asset/EditorialStatus eq ${filterValues.replace('Enum.EditorialStatus\'AppealPending\'', 'Enum.EditorialStatus\'RejectedAppealPending\' or Asset/EditorialStatus eq Enum.EditorialStatus\'ApprovedLimitedAppealPending\'')}`;
          return queryStr;
        },
      },
    });

    return odataOptions;
  }
}
